import { render, staticRenderFns } from "./propertyValueTable.vue?vue&type=template&id=1a9574d2&"
import script from "./propertyValueTable.vue?vue&type=script&lang=js&"
export * from "./propertyValueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports